import { render, staticRenderFns } from "./ComparateFormatter.vue?vue&type=template&id=0f318d45&functional=true"
import script from "./ComparateFormatter.vue?vue&type=script&lang=js"
export * from "./ComparateFormatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports